import React from "react";
import { Modal } from "antd";
import { Box } from "@chakra-ui/react";
import AccountPlanTree from "ui/components/AccountPlanTree";
import FooterModal from "ui/components/Button/FooterModal";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import useListFinancialCategory from "features/condominio/hooks/useListFinancialCategory";
import { useLoading } from "ui/components/GlobalLoading";

interface ModalPlanoContasProps {
  isOpen: boolean;
  onClose: () => any;
}

function ModalPlanoContas({ isOpen, onClose }: ModalPlanoContasProps) {
  const { tenant } = useCurrentTenant();

  const { data: categoriasModal, isLoading: isLoadingCategoriasModal } =
    useListFinancialCategory(tenant?.id);

  useLoading(isLoadingCategoriasModal);

  return (
    <Modal
      centered
      visible={isOpen}
      footer={
        <FooterModal
          registerAnother={false}
          setRegisterAnother={() => null}
          onClose={onClose}
          showRegisterAnother={false}
          buttonCancelarText="Fechar"
        />
      }
      onCancel={onClose}
      title="Categorias"
    >
      <Box>
        <AccountPlanTree edit data={categoriasModal ?? []} />{" "}
      </Box>
    </Modal>
  );
}

export default ModalPlanoContas;
